// extracted by mini-css-extract-plugin
export default {"icon":"UsersGroup_icon__JRZ8c"};